import { AdPreviewSquare } from './ad-preview/AdPreviewSquare'
import { AdPreviewVertical } from './ad-preview/AdPreviewVertical'
import { AdPreviewHorizontal } from './ad-preview/AdPreviewHorizontal'

// Utility functions for text truncation
export const truncateText = (text, maxLength) => {
    if (!text || text.length <= maxLength) return text
    return text.slice(0, maxLength - 1) + '…'
}

export const truncateHeadline = (text) => truncateText(text, 40)
export const truncateDescription = (text) => truncateText(text, 30)

// Utility to estimate if headline takes one line based on character count and container width
export const isTextSingleLine = (text, containerWidth = 300, fontSize = 14) => {
    if (!text) return true
    // Rough estimation: average character width is ~0.6 of font size
    const avgCharWidth = fontSize * 0.6
    const estimatedWidth = text.length * avgCharWidth
    return estimatedWidth <= containerWidth
}

export const AdPreview = (props) => {
    const { format = 'singleImage' } = props

    // Route to appropriate layout component based on format
    switch (format) {
        case 'vertical':
            return <AdPreviewVertical {...props} />
        case 'horizontal':
            return <AdPreviewHorizontal {...props} />
        default:
            // Square format for singleImage, carousel, video, and any other formats
            return <AdPreviewSquare {...props} />
    }
}
